import { __rest } from "tslib";
import * as React from 'react';
const DocumentFillSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M9,3 L9,7.5 C9,8.327 9.673,9 10.5,9 L10.5,9 L15,9 L15,14.5 C15,15.327 14.327,16 13.5,16 L13.5,16 L5.5,16 C4.673,16 4,15.327 4,14.5 L4,14.5 L4,4.5 C4,3.673 4.673,3 5.5,3 L5.5,3 L9,3 Z M10,3.318 C10.05,3.357 10.101,3.394 10.146,3.439 L10.146,3.439 L14.56,7.847 C14.607,7.894 14.646,7.948 14.687,8 L14.687,8 L10.5,8 C10.224,8 10,7.776 10,7.5 L10,7.5 Z" })));
};
DocumentFillSmall.displayName = 'DocumentFillSmall';
export default DocumentFillSmall;
//# sourceMappingURL=DocumentFillSmall.js.map